import { render } from "./UltimatePerformanceTest.vue?vue&type=template&id=49c6cc4d&scoped=true&ts=true"
import script from "./UltimatePerformanceTest.vue?vue&type=script&lang=ts"
export * from "./UltimatePerformanceTest.vue?vue&type=script&lang=ts"

import "./UltimatePerformanceTest.vue?vue&type=style&index=0&id=49c6cc4d&scoped=true&lang=css"
import "./UltimatePerformanceTest.vue?vue&type=style&index=1&id=49c6cc4d&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c6cc4d"]])

export default __exports__